import $ from 'jquery'

export default class NavButtonManager {
	constructor() {
		this.$document = $(document);
		this.$body = $("body");
		this.$toggleButton = $(".toggle_button");
		this.$document.on("pjaxResetEvent",this.removeClass.bind(this));
		this.addEvents();
	}

	removeClass(){
		if(this.$toggleButton.hasClass("open")){
			this.$toggleButton.removeClass("open");
		}
	}
	
	addEvents(){
		this.$toggleButton.on("click",(event)=>{
			const $eventTarget = $(event.currentTarget) 
			$eventTarget.toggleClass("open");
			event.stopPropagation();
		});
		this.$body.on("click",(e)=>{
			// if($toggleButton.hasClass("open")){
				this.$toggleButton.removeClass("open");

			// }
		});
	}
	removeEvents() {
		this.$toggleButton.off("click");
		this.$body.off("click");
	}


}